// ******** cadastrarempresa.jsx *********
// ******** autor: Walcledson de Paula ***
// ******** data: 08/08/24 20h04       ***
// ******** atualizações: 17/09/24 | 19h06 | correção de bugs ***
// ***************************************

import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';
import apiaxios from "../../../../Services/apiaxios.js";
import { encrypt, decrypt } from "../../../../Services/cryptoUtils.js";
import { AutoLogout } from '../../../../Services/autologout.js';
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';

import Menu from "../../Components/Menu/p_menu.jsx";
import './p_cadastrarempresa.css';
// import { jwtDecode } from 'jwt-decode';

function CadastroEmpresa() {
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        // // Decodifique o token para verificar o conteúdo
        // const decodedToken = jwtDecode(tokenASW);
        // console.log('token jwt dentro do cadastro empresa: ', decodedToken); // Verifique o conteúdo do token        
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    const navigate = useNavigate();
    const { state } = useLocation();
    // console.log("State recebido no useLocation cadstrarempresa: ", state);
    const [iduser, SetIduser] = useState(state?.iduser || null);
    const [indEmpresa, setIndEmpresa] = useState(state?.indEmpresa || null);
    const [from, setFrom] = useState(state?.from || null);
    // console.log (' iduser, indEmpresa, from - dentro cadastrarempresa ', iduser, indEmpresa, from)
    const MySwal = withReactContent(Swal);
    
    const [categorias, setCategorias] = useState([]);
    const [formData, setFormData] = useState({
        id_usuario: iduser,
        nome: '',
        cpfcnpj: '',
        link_personalizado: '',
        id_categoria: '',
        validado: 1
    });

    const headers = {
        params: {id_usuario: iduser,
                token: tokenASW
        }
    };

    const [cpfCnpjMask, setCpfCnpjMask] = useState("999.999.999-99"); // Inicialmente, máscara de CPF

    useEffect(() => {
        if (indEmpresa > 0) {
            navigate(from);
        }
    }, [indEmpresa, navigate, from]);

    useEffect(() => {
        const fetchCategorias = async () => {
            // console.log('iduser: dentro fetchcategorias',iduser);
            // alert('categoriasWeb');
            try {
                const response = await apiaxios.get(`/categoria/categoriasWeb?id_usuario=${iduser}&token=${tokenASW}`);
                if (response.status === 200) {
                    const sortedCategorias = response.data.sort((a, b) =>
                        a.DESCRICAO.localeCompare(b.DESCRICAO)
                    );
                    setCategorias(sortedCategorias);
                }
            } catch (error) {
                MySwal.fire('Erro', 'Erro ao buscar categorias. Tente novamente mais tarde.', 'error');
            }
        };

        fetchCategorias();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
        // setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // alert('submit');

        // // validação se o cpf/cnpj está válido
        // if (!formData.cpfValido || !formData.cnpjValido) {
        //     MySwal.fire('Erro', 'CPF ou CNPJ inválido.', 'error');
        //     return;
        // }

        // Validação do link personalizado
        if (formData.link_personalizado && formData.link_personalizado.length < 5) {
            MySwal.fire('Erro', 'O link personalizado deve ter no mínimo 5 caracteres.', 'error');
            return;
        }
        if (formData.link_personalizado && formData.link_personalizado.length > 30) {
            MySwal.fire('Erro', 'O link personalizado deve ter no máximo 30 caracteres.', 'error');
            return;
        }
        
        const validLinkRegex = /^[a-zA-Z][a-zA-Z0-9-_]{4,30}$/;
        // regras link_personalizado: mínimo 5 caracteres - máximo de 30. obrigatório letra no início. somente letras, números, (-) e (_) 9/8/24w
        if (formData.link_personalizado && !validLinkRegex.test(formData.link_personalizado)) {
            MySwal.fire('Erro', 'O link personalizado deve começar com uma letra e conter apenas letras, números, traço (-) e underline (_), com pelo menos 5 caracteres.', 'error');
            return;
        }
        
        const result = await MySwal.fire({
            title: 'Confirmação!',
            text: "Você confirma os dados de sua empresa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar!',
            allowOutsideClick: false, // Evita fechamento ao clicar fora
            allowEscapeKey: false // Evita fechamento ao pressionar a tecla "Escape"
        });

        if (result.isConfirmed) {
            try {
                const response = await apiaxios.post('/empresa/cadastroWeb', formData, headers);
                if (response.status === 200) {
                    MySwal.fire('Sucesso', 'Empresa cadastrada com sucesso!', 'success');

                    // // Atualiza o localStorage para refletir o cadastro completo
                    // const userData = JSON.parse(decrypt(localStorage.getItem("usuario")));
                    // userData.indEmpresa = 1;
                    // localStorage.setItem("usuario", encrypt(JSON.stringify(userData)));
                    // ✅ Correção: atualiza o tokenapw, que é a fonte real dos dados do usuário
                    const encryptedToken = localStorage.getItem('tokenapw');
                    if (encryptedToken) {
                        const token = decrypt(encryptedToken);
                        token.indempresa = 1; // note: o nome do campo é "indempresa", não "indEmpresa"
                        const updatedEncryptedToken = encrypt(token);
                        localStorage.setItem('tokenapw', updatedEncryptedToken);
                    }

                    navigate('/app/prestador/home');
                } else {
                    MySwal.fire('Erro', 'Falha ao cadastrar a empresa. Tente novamente.', 'error');
                }
            } catch (error) {
                const errorMessage = error.response?.data?.retorno || 'Erro de conexão. Verifique sua conexão e tente novamente.';
                MySwal.fire('Erro', errorMessage, 'error');
            }
        }
    };

    // const handleCpfCnpjChange = (e) => {
    //     const input = e.target.value.replace(/\D/g, '');

    //     if (input.length <= 11) {
    //         setCpfCnpjMask('999.999.999-999'); // CPF
    //     } else {
    //         setCpfCnpjMask('99.999.999/9999-99'); // CNPJ
    //     }

    //     setFormData({ ...formData, cpfcnpj: input });
    // };

    // const handleCpfCnpjChange = (e) => {
    //     const input = e.target.value.replace(/\D/g, '');
        
    //     if (input.length <= 11) {
    //         setCpfCnpjMask('999.999.999-999'); // CPF
    //         const cpfValido = validarCPF(input);
    //         setFormData({ ...formData, cpfcnpj: input, cpfValido });
    //     } else {
    //         setCpfCnpjMask('99.999.999/9999-99'); // CNPJ
    //         const cnpjValido = validarCNPJ(input);
    //         setFormData({ ...formData, cpfcnpj: input, cnpjValido });
    //     }
    // };

    // const handleCpfCnpjChange = (e) => {
    //     const input = e.target.value.replace(/\D/g, '');
    
    //     if (input.length <= 11) {
    //         setCpfCnpjMask('999.999.999-99'); // CPF
    //         const cpfValido = validarCPF(input);
    //         setFormData({ ...formData, cpfcnpj: input });
    //         if (!cpfValido && input.length === 11) {
    //             MySwal.fire('Erro', 'CPF inválido.', 'error');
    //         }
    //     } else {
    //         setCpfCnpjMask('99.999.999/9999-99'); // CNPJ
    //         const cnpjValido = validarCNPJ(input);
    //         setFormData({ ...formData, cpfcnpj: input });
    //         if (!cnpjValido && input.length === 14) {
    //             MySwal.fire('Erro', 'CNPJ inválido.', 'error');
    //         }
    //     }
    // };

    // const handleCpfCnpjChange = (e) => {
    //     const input = e.target.value.replace(/\D/g, '');
    //     console.log(input.length);
    //     if (input.length <= 11) {
    //         setCpfCnpjMask('999.999.999-99'); // CPF
    //         setFormData({ ...formData, cpfcnpj: input });
    
    //         // Validação de CPF
    //         if (input.length === 11) {
    //             const cpfValido = validarCPF(input);
    //             if (!cpfValido) {
    //                 MySwal.fire('Erro', 'CPF inválido.', 'error');
    //             }
    //         }
    //     } else if (input.length <= 14) {
    //         setCpfCnpjMask('99.999.999/9999-99'); // CNPJ
    //         setFormData({ ...formData, cpfcnpj: input });
    
    //         // Validação de CNPJ
    //         if (input.length === 14) {
    //             const cnpjValido = validarCNPJ(input);
    //             if (!cnpjValido) {
    //                 MySwal.fire('Erro', 'CNPJ inválido.', 'error');
    //             }
    //         }
    //     } else {
    //         // Se o input tiver mais de 14 caracteres, você pode optar por truncar ou não permitir a entrada.
    //         setFormData({ ...formData, cpfcnpj: input.slice(0, 14) });
    //     }
    // };

    const handleCpfCnpjChange = (e) => {
        const input = e.target.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

        // Atualiza a máscara baseada na quantidade de caracteres
        // if (input.length > 11) {
            setCpfCnpjMask('99.999.999/9999-99'); // CNPJ // inicialmente
        // } else if (input.length == 11) {
        //     setCpfCnpjMask('999.999.999-99'); // CPF
        // }

        // Atualiza o valor no formData
        setFormData({ ...formData, cpfcnpj: input });
    };
    
    const validarCNPJ = (cnpj) => {
        cnpj = cnpj.replace(/\D/g, ''); // Remove caracteres não numéricos
    
        if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) {
            return false; // Verifica se o CNPJ é inválido ou todos os dígitos são iguais
        }
    
        let soma = 0;
        let resto;
        const multiplicadores1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        const multiplicadores2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    
        // Validação do primeiro dígito verificador
        for (let i = 0; i < 12; i++) {
            soma += parseInt(cnpj.charAt(i)) * multiplicadores1[i];
        }
        resto = soma % 11;
        resto = resto < 2 ? 0 : 11 - resto;
        if (resto !== parseInt(cnpj.charAt(12))) {
            return false;
        }
    
        soma = 0;
        // Validação do segundo dígito verificador
        for (let i = 0; i < 13; i++) {
            soma += parseInt(cnpj.charAt(i)) * multiplicadores2[i];
        }
        resto = soma % 11;
        resto = resto < 2 ? 0 : 11 - resto;
        if (resto !== parseInt(cnpj.charAt(13))) {
            return false;
        }
    
        return true;
    };    

    const validarCPF = (cpf) => {
        cpf = cpf.replace(/\D/g, ''); // Remove caracteres não numéricos
    
        if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
            return false; // Verifica se o CPF é inválido ou todos os dígitos são iguais
        }
    
        let soma = 0;
        let resto;
    
        // Validação do primeiro dígito verificador
        for (let i = 0; i < 9; i++) {
            soma += parseInt(cpf.charAt(i)) * (10 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) {
            resto = 0;
        }
        if (resto !== parseInt(cpf.charAt(9))) {
            return false;
        }
    
        soma = 0;
        // Validação do segundo dígito verificador
        for (let i = 0; i < 10; i++) {
            soma += parseInt(cpf.charAt(i)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) {
            resto = 0;
        }
        if (resto !== parseInt(cpf.charAt(10))) {
            return false;
        }
    
        return true;
    };    
    
    // const handleBlur = () => {
    //     const { cpfcnpj } = formData;
    //     if (cpfcnpj.length === 11) {
    //         // Validar CPF
    //         const cpfValido = validarCPF(cpfcnpj);
    //         if (!cpfValido) {
    //             MySwal.fire('Erro', 'CPF inválido.', 'error');
    //         }
    //     } else if (cpfcnpj.length === 14) {
    //         // Validar CNPJ
    //         const cnpjValido = validarCNPJ(cpfcnpj);
    //         if (!cnpjValido) {
    //             MySwal.fire('Erro', 'CNPJ inválido.', 'error');
    //         }
    //     }
    // };

    // Valida quando o campo perde o foco (evento onBlur)
    const handleBlur = () => {
        const { cpfcnpj } = formData;

        if (cpfcnpj.length === 11) {
            // Validação de CPF
            setCpfCnpjMask('999.999.999-99'); // CPF
            const cpfValido = validarCPF(cpfcnpj);
            if (!cpfValido) {
                MySwal.fire('Erro', 'CPF inválido.', 'error');
            }
        } else if (cpfcnpj.length === 14) {
            // Validação de CNPJ
            const cnpjValido = validarCNPJ(cpfcnpj);
            if (!cnpjValido) {
                MySwal.fire('Erro', 'CNPJ inválido.', 'error');
            }
        } else {
            // Exibe mensagem se o CPF/CNPJ não tiver o tamanho correto
            MySwal.fire('Erro', 'CPF ou CNPJ incompleto.', 'error');
        }
    };

    // Valida quando o campo "link_personalizado" perde o foco (evento onBlur)
    const handleLinkBlur = async (e) => {
        e.preventDefault();

        // regras link_personalizado: mínimo 5 caracteres - máximo de 30. obrigatório letra no início. somente letras minúsculas, números, (-) e (_) 9/8/24w
        if (formData.link_personalizado && formData.link_personalizado.length > 30) {
            MySwal.fire('Erro', 'O link personalizado deve ter no máximo 30 caracteres.', 'error');
            return;
        }
        
        const validLinkRegex = /^[a-zA-Z][a-zA-Z0-9-_]{4,30}$/;

        if (formData.link_personalizado && !validLinkRegex.test(formData.link_personalizado)) {
            MySwal.fire('Erro', 'O link personalizado deve começar com uma letra e conter apenas letras, números, traço (-) e underline (_), com pelo menos 5 caracteres.', 'error');
            return;
        }
    };
    


    return (
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    <Menu page="cadastrarempresa" />
                </div>
                <div className="col py-3 me-3">
                    <div className="text-center">
                        <h1>Detalhes de sua empresa / negócio</h1>
                    </div>
                    <hr />

                    <div className="box-perfil">
                        <form onSubmit={handleSubmit}>
                            <label htmlFor="idempresa" className="col-sm-2 col-form-label">Usuário ID # {iduser}</label>
                            <div className="row mb-3">
                                <label htmlFor="nomefantasia" className="col-sm-2 col-form-label">Nome de Fantasia da Empresa</label>
                                <div className="col-sm-10">
                                    <input
                                        className="form-control"
                                        id="nomefantasia"
                                        placeholder='Digite o "Nome de Fantasia" de sua empresa (*)'
                                        autoComplete="address-level2"
                                        type="text"
                                        name="nome"
                                        value={formData.nome}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="perfilcpfcnpj" className="col-sm-2 col-form-label">CPF ou CNPJ</label>
                                <div className="col-sm-10">
                                    <InputMask
                                        mask={cpfCnpjMask}
                                        type="text"
                                        className="form-control"
                                        id="perfilcpfcnpj"
                                        placeholder="Digite o seu CPF ou CNPJ de sua empresa / negócio (*)"
                                        autoComplete="cpfcnpj"
                                        value={formData.cpfcnpj}
                                        onChange={handleCpfCnpjChange}
                                        onBlur={handleBlur} // Adiciona o evento onBlur para validação
                                        required
                                    />                                    
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="link_personalizado" className="col-sm-2 col-form-label">Link personalizado</label>
                                <div className="col-sm-10">
                                    <input
                                        className="form-control"
                                        id="link_personalizado"
                                        placeholder='Digite o "Link personalizado" que você usará'
                                        autoComplete="address-level2"
                                        type="text"
                                        name="link_personalizado"
                                        value={formData.link_personalizado}
                                        onChange={handleInputChange}
                                        onBlur={handleLinkBlur} // Adiciona o evento onBlur para validação
                                        // required
                                    />
                                </div>
                            </div>

                            
                            <div className="row mb-3">
                                <label htmlFor="empresacategoria" className="col-sm-2 col-form-label">Categoria</label>
                                <div className="col-sm-10">
                                    <select
                                        className="form-control"
                                        id="empresacategoria"
                                        name="id_categoria"
                                        value={formData.id_categoria}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="">Selecione uma categoria (*)</option>
                                        {categorias.map((categoria) => (
                                            <option key={categoria.ID_CATEGORIA} value={categoria.ID_CATEGORIA}>
                                                {categoria.DESCRICAO}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <button className='btn btn-primary' type="submit">Cadastrar Empresa</button>
                        </form>
                    </div>
                    <p className="text-sm">(*) campos obrigatórios.</p>
                </div>
            </div>
        </div>
    );
}

export default CadastroEmpresa;